import React, { useState, useEffect } from "react";
import axios from "lib/api";
import { mapSupplierByIdToUi } from "./mapOptionsToUi";
import { mapObjectionsToUi } from "modules/shared/profiles/mapObjectionsToUi";
const useFetchSupplierData = (supplierId, include) => {
    const [selectedSupplierData, setSelectedSupplierData] = useState(null);
    const [supplierAttachments, setSupplierAttachments] = useState(null);
    const [objections, setObjections] = useState({});

    const getSupplierById = async () => {
        try {
            const response = await axios.get(`/suppliers/${supplierId}`, {
                params: {
                    include: `${include}`,
                },
            });
            const supplierData = response?.data?.attributes;
            const included = response?.included;
            const attachments = included?.map((item) => {
                if (item?.type === "attachments") {
                    return { ...item?.attributes, id: item?.id };
                }
            });
            setSupplierAttachments(attachments);

            const paymentMethodData = included?.filter((item) => item?.type === "paymentMethods");
            setSelectedSupplierData(mapSupplierByIdToUi(supplierData, paymentMethodData));
            setObjections(mapObjectionsToUi(included));
        } catch (error) {
            return error;
        }
    };
    useEffect(() => {
        getSupplierById();
    }, [supplierId]);
    return { selectedSupplierData, supplierAttachments, setSupplierAttachments, objections };
};

export default useFetchSupplierData;
